import Index from './Index'
import Show from './Show'
import Overview from './Overview'

export default {
    Index,
    Show,
    Overview
}
